var commonStyles = {"component":"typography__component_wnj1q","bold":"typography__bold_wnj1q","semibold":"typography__semibold_wnj1q","medium":"typography__medium_wnj1q","regular":"typography__regular_wnj1q","rowLimit1":"typography__rowLimit1_wnj1q","rowLimit2":"typography__rowLimit2_wnj1q","rowLimit3":"typography__rowLimit3_wnj1q"};
require('./title/common.css');

exports.commonStyles = commonStyles;
